export default __webpack_public_path__ + "static/media/bg.974a1a33.webp";